import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";
import EmbedController from "../../../../embed/EmbedController";

export const HeadersBuildSection = ({
  brandLogo,
  headerLabel,
  headerLineImgSrc,
  subheaderLabel,
  finalPrice,
  currencySymbol,
  setShowBikeModal,
  productsState,
}) => {
  // custom code thrill code
  const displayBrandLogo = isMobile && EmbedController.isEmbedded ? false : true;

  // Black Friday discount logic
  const isBlackFridaySale = productsState.activeObj?.shopify?.isBlackFridaySale;
  const calculateBlackFridayDiscount = (price, symbol) => {
    if (!price || isNaN(price)) return null;

    // Calculate 30% discount (70% of original price)
    const discountedPrice = (price * 0.7).toFixed(2);

    return {
      original: `${symbol}${price.toFixed(2)}`,
      discounted: `${symbol}${discountedPrice}`,
    };
  };
  const blackFridayPriceData = isBlackFridaySale && finalPrice && currencySymbol ? calculateBlackFridayDiscount(finalPrice, currencySymbol) : null;

  return (
    <div className="headers d-flex flex-column pt-2">
      {blackFridayPriceData ? (
        <div className={`priceInHeader mt-1${!displayBrandLogo ? " priceInHeader--no-logo" : ""}`}>
          <div className="originalPrice">{blackFridayPriceData.original}</div>
          <div className="discountedPrice">{blackFridayPriceData.discounted}</div>
        </div>
      ) : (
        finalPrice && currencySymbol && <h5 className={`priceInHeader mt-1${!displayBrandLogo ? " priceInHeader--no-logo" : ""}`}>{`${currencySymbol}${finalPrice.toFixed(2)}`}</h5>
      )}
      {headerLabel && <h5 className="text-center pt-1 mb-0">{headerLabel}</h5>}
      {displayBrandLogo && (
        <>
          <img style={{ width: "130px" }} className="mx-auto mb-0" alt="brand logo" src={brandLogo} />
          <img style={{ width: "100px" }} className="mt-1 mx-auto" alt="header underline" src={headerLineImgSrc} />
        </>
      )}
      {subheaderLabel && (
        <div className="position-relative mt-1 mb-0">
          <h5 className="mb-0 text-center" style={{ cursor: "pointer", margin: "0 auto", position: "relative" }} onClick={() => setShowBikeModal(true)}>
            {subheaderLabel}
            <img
              src="/images/edit-red.png"
              alt="edit bike"
              style={{
                width: "16px",
                height: "16px",
                cursor: "pointer",
                marginLeft: "5px",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowBikeModal(true);
              }}
            />
          </h5>
        </div>
      )}
    </div>
  );
};

HeadersBuildSection.propTypes = {
  brandLogo: PropTypes.string,
  headerLabel: PropTypes.string,
  headerLineImgSrc: PropTypes.string,
  subheaderLabel: PropTypes.string,
  finalPrice: PropTypes.number,
  currencySymbol: PropTypes.string,
  setShowBikeModal: PropTypes.func,
};
